(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scroll-animations"] && !Shopify.designMode) return;
  try {
    class ScrollAnimations {
    constructor() {
      this.elements = document.querySelectorAll('[data-scroll-animate]');
      this.observer = null;
      this.init();
    }

    init() {
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const delay = entry.target.dataset.scrollDelay || 0;
                setTimeout(() => {
                  entry.target.classList.add('animate-in');
                }, delay);
                this.observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
          }
        );

        this.elements.forEach((el) => {
          this.observer.observe(el);
        });
      } else {
        this.elements.forEach((el) => {
          el.classList.add('animate-in');
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ScrollAnimations();
    });
  } else {
    new ScrollAnimations();
  }
  } catch(e) { console.error(e); }
})();

})();
